import { render, staticRenderFns } from "./create-customs-declaration-element.vue?vue&type=template&id=2d24b9fa"
import script from "./create-customs-declaration-element.vue?vue&type=script&lang=ts"
export * from "./create-customs-declaration-element.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports